document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-add]');
  if (!btn || !btn.dataset.variantId) return;

  event.preventDefault();
  btn.classList.add('opacity-50', 'pointer-events-none');

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }),
    });

    if (!response.ok) throw new Error('add failed');

    document.dispatchEvent(new CustomEvent('cart:product:added'));

    if (window.location.pathname === '/cart') {
      setTimeout(() => window.location.reload(), 800);
    }
  } catch {
    btn.classList.remove('opacity-50', 'pointer-events-none');
  }
});